import React from "react";
import { useProSidebar } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import notificationIcon from "src/images/notification-icon.png";
import { BurgerIcon } from "src/svg";

const PageHeader = ({ user }) => {
	const { toggleSidebar, toggled } = useProSidebar();

	return (
		<div className="pageHeader">
			<button className="tw-rounded-full tw-p-2 hover:tw-bg-gray-100 min-[1000px]:tw-hidden" onClick={() => toggleSidebar(!toggled)}>
				<BurgerIcon className="tw-h-[22px] tw-w-[22px]" />
			</button>
			<div className="tw-ml-auto tw-flex tw-items-center tw-gap-4">
				<Link to="/notifications">
					<div className="notification">
						<img src={notificationIcon} alt="Notifications" />
						<span className="notification-indicator"></span>
					</div>
				</Link>

				<div className="username">
					<Link to="/profile">
						<h4>
							{user?.first_name || "User"} {user?.last_name || "Name"}
						</h4>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default PageHeader;
